import { render, staticRenderFns } from "./workbench.vue?vue&type=template&id=31f33aaa&scoped=true"
import script from "./workbench.vue?vue&type=script&lang=js"
export * from "./workbench.vue?vue&type=script&lang=js"
import style0 from "./workbench.vue?vue&type=style&index=0&id=31f33aaa&prod&lang=css"
import style1 from "./workbench.vue?vue&type=style&index=1&id=31f33aaa&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f33aaa",
  null
  
)

export default component.exports